export default "__VITE_ASSET__CupHxNIE__"